import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
const LogoutMenu = {
    id: 'logoutRoot',
    title: 'LogOut',
    type: 'group',
    url: '/logout',
    icon: LogoutOutlinedIcon
}
export default LogoutMenu